/// <reference path="../bower_components/jquery/dist/jquery.js" />
/// <reference path="../bower_components/slick-carousel/slick/slick.js" />
function initializeListing() {

    function is_touch_device() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }

    function loadNextImage() {
        $nextSlideImg = $('#listing-carousel .slick-slide.slick-active').next().find('img[data-lazy]');
        if ($nextSlideImg.length === 1) {
            var src = $nextSlideImg.data('lazy');
            $nextSlideImg.attr('src', src).removeAttr('data-lazy').removeClass('slick-loading');
        }
    }

    $('.add-to-watch-list').click(function() {
        var el = $(this);
        if (el.hasClass("saved")) {
            deleteFromWatchListButton(el);
        } else {
            addToWatchList(el);
        }
    });

    if ($('#listing').length > 0) {

        var $listingCarousel = $('#listing-carousel');
        var $listingCarouselNav = $('#listing-carousel-nav');
        var media = parseInt($listingCarousel.data('slidecount'));
        var imagesRendered = parseInt($listingCarousel.data('imagesrendered'));
        var imageCount = parseInt($listingCarousel.data('imagecount'));

        var loadSlides = function() {
            if (imageCount !== imagesRendered) {
                var listingId = $listingCarousel.data('listingid'),
                    lastWrite = $listingCarousel.data('lastwrite'),
                    marketingAddress = $listingCarousel.data('marketingaddress');

                $listingCarousel.slick('slickRemove', imagesRendered);
                for (var i = 1; i <= imageCount - 1; i++) {
                    $listingCarousel.slick('slickAdd', '<div class="product-media"><div class="embed-responsive embed-responsive-16by9"><div class="embed-responsive-item"><img data-lazy=https://bayleys-pri-images-cdn-endpoint.azureedge.net/listing-images/' + listingId + '/' + listingId + '_' + (i + 1) + '_Listing_v2.jpg?v=' + lastWrite + '" width="1280" height="720" class="listing-photo listing-photo-zoom" alt="' + marketingAddress + '" /><span class="spinner-animated z-index-fix-n1"></span></div></div></div>');
                }
                imagesRendered = imageCount;
                $listingCarousel.slick('slickSetOption', 'infinite', true, true);
            }
        };

        var listingMainSlick = function () {
            $listingCarousel.on('init', function (event, slick) {
                $('.slick-counter').html('1 of ' + media);
                $('[data-toggle="tooltip"]').tooltip();
            });
            $listingCarousel.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev" data-toggle="tooltip" data-placement="right" title="Previous"><svg class="svg svg-icon-arrow-left"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-left"></use></svg></button>',
                nextArrow: '<button type="button" class="slick-next" data-toggle="tooltip" data-placement="left" title="Next"><svg class="svg svg-icon-arrow-right"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-right"></use></svg></button>'
            });
            if (media < 3) {
                $listingCarousel.slick('slickSetOption', 'infinite', false, true);
            }
            $listingCarousel.on('afterChange', function (event, slick, currentSlide) {
                loadNextImage();
                if (!$($('#listing-carousel .slick-slide')[currentSlide]).hasClass('viewed') && currentSlide !== 0) {
                    var listingId = $listingCarousel.data('listingid');
                    analyticsListingImageView(listingId);
                    $($('#listing-carousel .slick-slide')[currentSlide]).addClass('viewed');
                }
                $('.slick-counter').html(currentSlide + 1 + ' of ' + media);
            });
            $listingCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                loadSlides();
            });
            $listingCarousel.find('.slick-prev').click(function(event) {
                var imagesRendered = parseInt($listingCarousel.data('imagesrendered'));
                if (imagesRendered !== imageCount) {
                    event.preventDefault();
                    loadSlides();
                    $listingCarousel.slick('slickPrev');
                }
            });
            $listingCarousel.on('swipe', function(event, slick, direction){
                var imagesRendered = parseInt($listingCarousel.data('imagesrendered'));
                if (direction === 'right' && imagesRendered !== imageCount) {
                    loadSlides();
                    $listingCarousel.slick('slickPrev');
                }
            });
            $listingCarousel.on('lazyLoadError', function(event, slick, image, imageSource) {
                image.attr('src', '/public/img/svg/no-photo-950x551.svg');
            });
            loadNextImage();
        };
        
        var listingNavSlick = function () {

            $listingCarouselNav.on('inview', function (event, isInView) {
                if (isInView) {
                    $listingCarouselNav.slick({
                        slidesToShow: 7,
                        lazyLoad: 'ondemand',
                        dots: false,
                        arrows: false,
                        focusOnSelect: true,
                        asNavFor: $listingCarousel
                    });
                    if (media > 7) {
                        $listingCarouselNav.slick('slickSetOption', 'centerMode', true, true);
                    }
                    else {
                        $listingCarouselNav.slick('slickSetOption', 'infinite', false, true);
                    }

                    $listingCarousel.slick('slickSetOption', 'asNavFor', '#listing-carousel-nav');
                    $listingCarouselNav.slick('slickGoTo', $listingCarousel.slick('slickCurrentSlide'), false);

                    $listingCarouselNav.on('lazyLoadError', function (event, slick, image, imageSource) {
                        image.attr('src', '/public/img/svg/no-photo-350x197.svg');
                    });
                    $listingCarouselNav.off('inview');
                }
            });
        };

        listingMainSlick();
        listingNavSlick();

        $('#shareModal .modal-dialog .modal-content, #siteContact .modal-dialog .modal-content').css('background-image', 'url("' + $('#modal-share-background').attr('src') + '")');

        var openHomes = $('#open-homes .open-home').length;
        if (openHomes > 4){
            $('.open-home-plural').text('s');
            $('#open-homes .ibox-footer').addClass('internal-shadow');
        }

        $agentImages = $('#agents .profile-image img[data-src]');
        $agentImages.on('inview', function (event, isInView) {
            if (isInView) {
                $agentImages.each(function () {
                    var $this = $(this);
                    $this.attr('src', $this.data('src'));
                    $this.removeData('src');
                });
                $agentImages.off('inview');
            }
        });
    }
}